import { 
  FETCH_KEYWORDS_FAILURE, 
  FETCH_KEYWORDS_REQUEST, 
  FETCH_KEYWORDS_RESET, 
  FETCH_KEYWORDS_SUCCESS 
} from "../../../../redux/types/pvs";

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
}

const fetchKeywordsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_KEYWORDS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      }

    case FETCH_KEYWORDS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload.message || "Something went wrong",
      }

    case FETCH_KEYWORDS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error || "Something went wrong",
        success: false,
        message: ""
      }

    case FETCH_KEYWORDS_RESET:
      return {
        ...initialState,
      }

    default:
      return state
  }
}

export default fetchKeywordsReducer;